module.exports = __webpack_public_path__ + "img/radio-bandeirantes2.be6dd11a.png";